/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useSelectItemCatalogueIconStyles = makeStyles((theme: Theme) => ({
  iconCheck: {
    opacity: 0,
  },
  iconArrow: {
    transform: 'rotate(-90deg)',
    opacity: 0,
  },
  iconWarn: {
    color: theme.palette.error.main,
  },
  iconError: {
    color: '#FA634E',
  },
}));
